<template>
  <div class="banner pr">
    <swiper v-if="list.length" class="custom-swiper" :options="swiperOption">
      <swiper-slide v-for="(item,i) in list" :key="item.id">
        <van-image class="banner-img" :src="item.ImageUrl" alt="" @click="handleClick(item.Link,i)"/>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { gioTracking } from '@/plugins/common'
export default {
  name: 'IndexBanner',

  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },

  data () {
    return {
      swiperOption: {
        autoplay: true,
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },

  methods: {
    handleClick (url, i) {
      gioTracking('track', 'evt_AdsClicked', {
        adsType: 'bn',
        bnOrder: i
      })
      if (url === null) return
      location.href = url
    }
  }
}
</script>

<style lang="less" scoped>
.banner {
  height: 480px;
  .banner-bg {
    height: 332px;
    background-color: @main-color;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: -22px;
      right: 0;
      z-index: 1;
      height: 22px;
      background: url("../../assets/index_banner_bg.png") 0 0 no-repeat;
      background-size: 100% 100%;
    }
  }
  .custom-swiper {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 2;
    width: 7.5rem;
    height: 480px;
    margin-left: -375px;
    // border-radius: 8px;
    .banner-img {
      width: 100%;
      height: 480px;
      ::v-deep img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
